import { useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { createIcon } from '@blade/ui-kit'
import { supportTicketTotalUnread } from '@root/features/support'
import { SupportDialog } from '@root/features/support/ui/support-dialog'

export const SupportButton: React.FC = () => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const [totalUnread] = useAtom(supportTicketTotalUnread)
  const countFormatted = totalUnread > 99 ? '99+' : totalUnread.toString()

  return (
    <SupportDialog
      open={open}
      onOpenChange={setOpen}
      trigger={
        <TriggerButton data-open={open} type="button">
          <SupportIcon size={14} />
          <Text>{t('support')}</Text>
          <CounterBadge data-has-value={totalUnread > 0}>
            {countFormatted}
          </CounterBadge>
        </TriggerButton>
      }
    />
  )
}

const TriggerButton = styled.button`
  all: unset;
  box-sizing: border-box;
  height: 16px;
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 2px;
  cursor: pointer;
  transition: all 0.15s linear;

  &[data-open='false'] {
    color: var(--text-9);
    &:hover {
      color: var(--text-10);
    }
  }
  &[data-open='true'] {
    color: var(--text-11);
  }
`

const Text = styled.div`
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px;
  padding-inline: 0 2px;
`

const CounterBadge = styled.div`
  height: 12px;
  border-radius: 3px;
  padding-inline: 4px;

  display: grid;
  align-items: center;
  justify-content: center;

  font-size: 8px;
  font-weight: 600;
  line-height: 12px;

  background: var(--background-2);
  color: var(--text-9);

  &[data-has-value='true'] {
    background: var(--up-9);
    color: var(--appearance-1, #000);
  }
`

const SupportIcon = createIcon(
  <>
    <path
      d="M7 0.875C4.1125 0.875 1.75 3.19375 1.75 6.08125V7.6125C1.75 7.65625 1.75 7.65625 1.75 7.7C1.75 7.74375 1.75 7.83125 1.75 7.875C1.75 9.1 2.7125 10.0625 3.9375 10.0625C4.2 10.0625 4.375 9.8875 4.375 9.625V6.125C4.375 5.8625 4.2 5.6875 3.9375 5.6875C3.45625 5.6875 2.975 5.8625 2.625 6.125V6.0375C2.625 3.675 4.59375 1.75 7 1.75C9.40625 1.75 11.375 3.675 11.375 6.08125V6.125C11.025 5.8625 10.5437 5.6875 10.0625 5.6875C9.8 5.6875 9.625 5.8625 9.625 6.125V9.625C9.625 9.8875 9.8 10.0625 10.0625 10.0625C10.3687 10.0625 10.675 9.975 10.9375 9.8875C10.5 10.8062 9.7125 11.5063 8.75 11.9C8.75 11.8563 8.75 11.8562 8.75 11.8125C8.75 11.55 8.575 11.375 8.3125 11.375H7C6.7375 11.375 6.5625 11.55 6.5625 11.8125V12.6875C6.5625 12.95 6.7375 13.125 7 13.125C9.8875 13.125 12.25 10.85 12.25 8.05V7.6125V6.5625V6.08125C12.25 3.19375 9.8875 0.875 7 0.875Z"
      fill="currentColor"
    />
  </>,
  '0 0 14 14',
)
